export default __webpack_public_path__ + "static/media/refresh-icon.ef1b3e6a.svg";